<template>
  <div />
</template>

<script>
export default {
  name: 'Toast',
  created() {
    this.$store.watch(
      (state) => state.app.toastMessage,
      (newToastMessage) => {
        if (newToastMessage) {
          this.$toast.success(newToastMessage.message, {
            position: 'top-center',
            toastClassName: 'my-custom-toast-class',
            timeout: 3000,
            icon: false,
            onClose: () => {
              if (newToastMessage.func && typeof newToastMessage.func === 'function') {
                newToastMessage.func()
              }
              if (newToastMessage.close) {
                this.$store.commit('SET_TOAST_MESSAGE', null) // Clear the toast message from the state after it's shown
              }
            }
          })
        }
      }
    )
  }
}
</script>

<style>
 .Vue-Toastification__toast--success.my-custom-toast-class {
        background-color: black ;
    }
</style>

